<mat-card class="digital-contract">
  <mat-card-content class="mat-card-content-contract-sm w-100 bg-white">
    <mat-accordion #accordion="matAccordion" [multi]="true" class="row w-100">
      <div [hidden]="isViewFull" class="col-5 digital-contract_infor" style="padding: 0 10px 5px !important;" >
        <mat-expansion-panel class="mat-elevation-z "
                             expanded="true"
                             style="margin-left: -30px !important;"
                             #mePanel="matExpansionPanel"
        >
          <mat-expansion-panel-header>
            <!-- Thông tin liên hệ -->
            <mat-panel-title class="mat-panel-title justify-content-between">
               <span *ngIf="mode !== 'view'">
              {{ 'form.digital_contract.document_information' | translate }}
            </span>
              <span *ngIf="mode === 'view'" class="content-view">
              {{ 'form.digital_contract.view_document' | translate }} {{ mainFormAdd.controls.docCode.value }}
            </span>
              <small *ngIf="mode !== 'view'" class="form-text text-gray pull-left">(<span
                style="color: red;">*</span>) {{
                  'form.info' |
                    translate
                }}
              </small>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div *ngIf="mode !== 'view'">
            <form [formGroup]="mainFormAdd" class="py-3">
              <!--Loại hợp đồng-->
              <mat-form-field class="w-100">
                <mat-label>{{ 'form.digital_contract.document_type' | translate }}</mat-label>
                <mat-select #serviceTypeSelect (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)"
                            (focusout)="(checkFocus = true)"
                            (selectionChange)="checkFocus = false"
                            formControlName="docType" required>
                  <mat-option>
                    <ngx-mat-select-search [formControl]="serviceTypeCtrl"
                                           [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                           [placeholderLabel]="'search_form.search' | translate">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)"
                              *ngFor="let serviceType of filteredServiceTypes | async"
                              [value]="serviceType.id">
                    {{ serviceType.name }}
                  </mat-option>
                </mat-select>
                <button (click)="mainFormAdd.controls.docType.reset('')"
                        *ngIf="mainFormAdd.controls.docType.value && mode !== 'view' && !mainFormAdd.controls.docParent.value"
                        aria-label="Clear" mat-button
                        mat-icon-button matSuffix type="button">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="mainFormAdd.controls.docType.hasError('required')">
                  {{ 'digital_contract.error.service_type_required' | translate }}
                </mat-error>
              </mat-form-field>

              <!--  tên hợp đồng-->
              <mat-form-field class="w-100">
                <input (focusout)="focusOut('docName')"
                       [placeholder]="'form.digital_contract.document_name' | translate" formControlName="docName"
                       matInput
                       maxlength="100" required
                       type="text">
                <button (click)="reset('docName')" *ngIf="mainFormAdd.controls.docName.value && mode !== 'view'"
                        aria-label="Clear" mat-button
                        mat-icon-button matSuffix type="button">
                  <mat-icon>close</mat-icon>
                </button>

                <mat-error *ngIf="mainFormAdd.controls.docName.hasError('required')">
                  {{ 'digital_contract.error.contract_name_required' | translate }}
                </mat-error>
              </mat-form-field>

              <!--  mã hợp đồng-->
              <mat-form-field class="w-100">
                <input (focusout)="focusOut('docCode')"
                       [placeholder]="'form.digital_contract.document_code' | translate" formControlName="docCode"
                       matInput
                       maxlength="50" required
                       type="text">
                <button (click)="reset('docCode')" *ngIf="mainFormAdd.controls.docCode.value && mode !== 'view'"
                        aria-label="Clear" mat-button
                        mat-icon-button matSuffix type="button">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="mainFormAdd.controls.docCode.hasError('required')">
                  {{ 'digital_contract.error.contract_code_required' | translate }}
                </mat-error>
                <mat-error *ngIf="mainFormAdd.controls.docCode.hasError('pattern')">
                  {{ "digital_contract.error.contract_code_pattern" | translate }}
                </mat-error>
                <mat-error *ngIf="mainFormAdd.controls.docCode.hasError('matched')">
                  {{ "validation.document_code_duplicate" | translate }}
                </mat-error>
              </mat-form-field>

              <!--      Ngày hiệu lực từ ngày đến ngày-->
              <mat-form-field class="w-100">
                <input (change)="someMethod($event.target)" (focusout)="dateFocusOut('effectiveDate')"
                       (input)="someMethod($event.target); dateField = 'effectiveDate'"
                       [matDatepicker]="dp3"
                       [max]="mainFormAdd.controls.expirationDate.value"
                       [placeholder]="'form.digital_contract.effective_date' | translate"
                       formControlName="effectiveDate"
                       matInput
                       required>
                <mat-datepicker-toggle [for]="dp3" matSuffix>

                </mat-datepicker-toggle>
                <mat-datepicker #dp3></mat-datepicker>
                <mat-error
                  *ngIf="mainFormAdd.controls.effectiveDate.hasError('required') && !mainFormAdd.controls.effectiveDate.hasError('matDatepickerParse')">
                  {{ 'digital_contract.error.effective_time_required' | translate }}
                </mat-error>
                <mat-error
                  *ngIf="mainFormAdd.controls.effectiveDate.hasError('matDatepickerMax') && dateField === 'effectiveDate'">
                  {{ "digital_contract.error.effectiveDate_validate" | translate }}
                </mat-error>
                <mat-error *ngIf="mainFormAdd.controls.effectiveDate.hasError('matDatepickerParse')">
                  {{ "digital_contract.error.date_pattern" | translate }}
                </mat-error>
              </mat-form-field>

              <mat-form-field class="w-100">
                <input (focusout)="dateFocusOut('expirationDate')" (input)="dateField = 'expirationDate'"
                       [matDatepicker]="dp4"
                       [min]="mainFormAdd.controls.effectiveDate.value"
                       [placeholder]="'form.digital_contract.expiration_date' | translate"
                       formControlName="expirationDate"
                       matInput>
                <mat-datepicker-toggle [for]="dp4" matSuffix>

                </mat-datepicker-toggle>
                <mat-datepicker #dp4></mat-datepicker>
                <mat-error
                  *ngIf="mainFormAdd.controls.expirationDate.hasError('matDatepickerMin') && dateField === 'expirationDate'">
                  {{ "digital_contract.error.expiredDate_validate" | translate }}
                </mat-error>
                <mat-error *ngIf="mainFormAdd.controls.expirationDate.hasError('matDatepickerParse')">
                  {{ "digital_contract.error.date_pattern" | translate }}
                </mat-error>

              </mat-form-field>

              <!--  Mô tả-->
              <mat-form-field class="w-100">
                <input (focusout)="focusOut('description')"
                       [placeholder]="'form.digital_contract.description' | translate" formControlName="description"
                       matInput maxlength="200"
                       type="text">
                <button (click)="mainFormAdd.controls.description.reset('')"
                        *ngIf="mainFormAdd.controls.description.value" aria-label="Clear" mat-button
                        mat-icon-button matSuffix type="button">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <!-- Cho phép khách hàng xem nội dung -->
              <div class="w-100">
                <mat-checkbox  formControlName="allowReferenceCustomerView" color="primary"><strong>{{'form.digital_contract.allow_reference_customer_view' | translate}}</strong></mat-checkbox>
              </div>
            </form>
          </div>

          <!-- View contract -->
          <div *ngIf="mode === 'view'" class="mt-3">
            <!-- Mã hợp đồng -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'form.digital_contract.document_code' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ mainFormAdd.controls.docCode.value }}</b>
              </div>
            </div>

            <!-- Tên hợp đồng -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'form.digital_contract.document_name' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ mainFormAdd.controls.docName.value }}</b>
              </div>
            </div>

            <!-- Loại hợp đồng -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'form.digital_contract.document_type' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ mainFormAdd.controls.docType.value }}</b>
              </div>
            </div>
            <!-- Trạng thái -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'search_form.status' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <nz-tag *ngIf="contractStatus == 1">{{ 'search_form.draft' | translate }}</nz-tag>
                <nz-tag *ngIf="contractStatus == 7" [nzColor]="'red'">{{ 'search_form.cancelled' | translate }}</nz-tag>
                <nz-tag *ngIf="contractStatus == 8" [nzColor]="'green'">{{ 'contract_share_partner.issued' | translate }}</nz-tag>
              </div>
            </div>

            <!-- Ngày hiệu lực -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'form.digital_contract.effective_date' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ mainFormAdd.controls.effectiveDate.value }}</b>
              </div>
            </div>

            <!-- Ngày hết hiệu lực -->
            <div class="row my-4">
              <label class="col-lg-5 col-md-6">
                {{ 'form.digital_contract.expiration_date' | translate }}
              </label>
              <div class="col-lg-7 col-md-6 content-view">
                <b>{{ mainFormAdd.controls.expirationDate.value }}</b>
              </div>
            </div>
            <!-- Mô tả -->
            <div class="row my-4">
              <label class="col-12">
                {{ 'form.digital_contract.description' | translate }}
              </label>
              <div class="col-12 content-view">
                <b>{{ mainFormAdd.controls.description.value }}</b>
              </div>
            </div>
            <div class="row my-4">
              <div class="col-12">
                <mat-checkbox [disabled]="true" [(ngModel)]="mainFormAdd?.getRawValue().allowReferenceCustomerView" [ngModelOptions]="{ standalone: true }" color="primary"><div style="font-weight: 600; color: #000;">{{'form.digital_contract.allow_reference_customer_view' | translate}}</div></mat-checkbox>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-elevation-z mt-3" *ngIf="(mode === 'view' && dataDocumentParent && dataDocumentParent.length > 0) || mode !== 'view'"
                             expanded="true"
                             style="margin-left: -30px !important;"
                             #mePanel="matExpansionPanel"
        >
          <mat-expansion-panel-header>
            <!-- Thông tin liên hệ -->
            <mat-panel-title class="mat-panel-title justify-content-between">
              <span>{{ 'form.digital_contract.document_parent' | translate }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div *ngIf="mode !== 'view'">
            <form [formGroup]="mainFormAdd" class="py-3">
              <!--  Hợp đồng cha-->
              <div class="w-100 ">
                <form nz-frm>
                  <nz-table #editRowInternalTable nzBordered [nzData]="dataDocumentParent" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable1"
                            [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                    <tr>
                      <th class="text-center" nzWidth="25px">
                        {{
                          "enterprise_contract.panel_document.table_users.header.order"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="60%">
                        {{
                          "form.digital_contract.document_information"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="100px">{{ 'search_form.status' | translate}}</th>
                      <th class="text-center">
                        <!--                        {{-->
                        <!--                          "enterprise_contract.panel_document.table_users.header.action"-->
                        <!--                            | translate-->
                        <!--                        }}-->
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
                      <!-- TT -->
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- Tên -->
                      <td class="word-break-line">
                        <div class="editable-cell">
                          <div class="row-icon"> {{ data.code }}
                            - {{ data.name }}
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <span *ngIf="data.status == 1">{{ 'search_form.draft' | translate}}</span>
                        <span *ngIf="data.status == 2">{{ 'search_form.processing' | translate}}</span>
                        <span *ngIf="data.status == 3">{{ 'search_form.denied_sign' | translate}}</span>
                        <span *ngIf="data.status == 4 && data.contractTerminationStatus != 2 && data.contractTerminationStatus != 4">{{ 'search_form.finish' | translate}}</span>
                        <span *ngIf="data.status == 5">{{ 'search_form.cancelled' | translate}}</span>
                        <span *ngIf="data.status == 6">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
                        <span *ngIf="data.status == 7">{{ 'contract_share_partner.issued' | translate}}</span>
                        <span *ngIf="data.status == 8">{{ 'contract_share_partner.issued' | translate}}</span>
                        <span *ngIf="data.status == 9">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
                        <span *ngIf="data.status == 4 && data.contractTerminationStatus == 2">{{ 'contract_terminate.terminating' | translate}}</span>
                        <span *ngIf="data.status == 4 && data.contractTerminationStatus == 4">{{ 'contract_terminate.terminated' | translate}}</span>
                      </td>
                      <!-- Action -->
                      <td class="td-nz-icon text-center">
                        <button mat-icon-button (click)="viewContract(data)" *ngIf="data.id && mode !== 'view'" aria-label="View" style="color: #07736C">
                          <mat-icon>
                            visibility
                          </mat-icon>
                        </button>
                        <button (click)="onClickDeleteElementRecordInternalUser(data.id)"
                                *ngIf="data.id && mode !== 'view'" aria-label="Clear"
                                mat-button mat-icon-button matSuffix style="color: #ee0033"
                                type="button">
                          <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                        </button>
                      </td>
                    </tr>
                    <tr class="editable-row">
                      <!-- TT -->
                      <td class="text-center">&nbsp;</td>
                      <!-- Tên -->
                      <td colspan="3">
                        <div>
                          <nz-input-group [nzSuffix]="suffixPartyInput">
                            <input nz-input [(ngModel)]="inputInternalDocumentsValue" (input)="getParentContractNew($event)"
                                   [nzAutocomplete]="autoInternalUserSearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                        'placeholder.document_parent' | translate
                      }}" #autocompleteInput id="inputUser1" />
<!--                            <input  nz-input [(ngModel)]="inputInternalDocumentsValue"-->
<!--                                    (keyup)="getParentContractNew($event)"-->
<!--                                    [nzAutocomplete]="autoInternalUserSearching"-->
<!--                                    [ngModelOptions]="{ standalone: true }"-->
<!--                                    placeholder="{{ 'placeholder.document_parent' | translate }}"-->
<!--                                    #autocompleteInput id="inputUser1"/>-->
                            <nz-autocomplete #autoInternalUserSearching>
                              <nz-auto-option *ngFor="let user of parentContracts"
                                              (selectionChange)="autocompleteInternalUserSelected($event, user)"
                                              [nzValue]="''">
                                <div class="d-flex">
                                  <span style="line-height: 20px">
                                      {{ user.code }} - {{ user.name }}
                                    </span>
                                </div>
                              </nz-auto-option>
                            </nz-autocomplete>
                          </nz-input-group>
                          <ng-template #suffixPartyInput>
                            <nz-spin *ngIf="nzCheckLoadingParty1" nzSimple [nzIndicator]="indicatorPartyInput"></nz-spin>
                          </ng-template>
                          <ng-template #indicatorPartyInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                               style="font-size: 24px"></i>
                          </ng-template>
                        </div>
                      </td>
                      <!-- Thực hiện -->
                      <!--                      <td class="td-nz-icon text-center">&nbsp;</td>-->
                    </tr>
                    </tbody>
                  </nz-table>
                  <ng-template #contentEmptyTable1 ></ng-template>
                </form>
              </div>
            </form>
          </div>

          <!-- View contract -->
          <div *ngIf="mode === 'view' && dataDocumentParent && dataDocumentParent.length > 0" class="mt-3">
            <nz-table #editRowInternalTable nzBordered [nzData]="dataDocumentParent" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                      [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
              <thead>
              <tr>
                <th class="text-center" nzWidth="25px">
                  {{
                    "enterprise_contract.panel_document.table_users.header.order"
                      | translate
                  }}
                </th>
                <th class="text-center" nzWidth="80%">
                  {{
                    "form.digital_contract.document_information"
                      | translate
                  }}
                </th>
                <th class="text-center" nzWidth="100px">{{ 'search_form.status' | translate}}</th>
                <th class="text-center">
                  <!--                        {{-->
                  <!--                          "enterprise_contract.panel_document.table_users.header.action"-->
                  <!--                            | translate-->
                  <!--                        }}-->
                </th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
                <!-- TT -->
                <td class="text-center">{{ i + 1 }}</td>
                <!-- Tên -->
                <td class="word-break-line">
                  <div class="editable-cell">
                    <div class="row-icon"> {{ data.code }}
                      - {{ data.name }}
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <span *ngIf="data.status == 1">{{ 'search_form.draft' | translate}}</span>
                  <span *ngIf="data.status == 2">{{ 'search_form.processing' | translate}}</span>
                  <span *ngIf="data.status == 3">{{ 'search_form.denied_sign' | translate}}</span>
                  <span *ngIf="data.status == 4 && data.contractTerminationStatus != 2 && data.contractTerminationStatus != 4">{{ 'search_form.finish' | translate}}</span>
                  <span *ngIf="data.status == 5">{{ 'search_form.cancelled' | translate}}</span>
                  <span *ngIf="data.status == 6">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
                  <span *ngIf="data.status == 7">{{ 'contract_share_partner.issued' | translate}}</span>
                  <span *ngIf="data.status == 8">{{ 'contract_share_partner.issued' | translate}}</span>
                  <span *ngIf="data.status == 9">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
                  <span *ngIf="data.status == 4 && data.contractTerminationStatus == 2">{{ 'contract_terminate.terminating' | translate}}</span>
                  <span *ngIf="data.status == 4 && data.contractTerminationStatus == 4">{{ 'contract_terminate.terminated' | translate}}</span>
                </td>
                <!-- Action -->
                <td class="td-nz-icon text-center">
                  <button mat-icon-button (click)="viewContract(data)" *ngIf="data.id " aria-label="View" style="color: #07736C">
                    <mat-icon>
                      visibility
                    </mat-icon>
                  </button>
                </td>
              </tr>
              </tbody>
            </nz-table>
            <ng-template #contentEmptyTable ></ng-template>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-elevation-z mt-3"
                             expanded="true"
                             style="margin-left: -30px !important;"
                             #mePanel="matExpansionPanel" *ngIf="(mode === 'view' && RECORD_PARTY_SIGN && RECORD_PARTY_SIGN.length > 0) || mode !== 'view'"
        >
          <mat-expansion-panel-header>
            <!-- Thông tin liên hệ -->
            <mat-panel-title class="mat-panel-title justify-content-between">
              <span>{{ 'form.digital_contract.customer_parent' | translate }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div *ngIf="mode !== 'view'">
            <form [formGroup]="mainFormAdd" class="py-3">
              <!--  Hợp đồng cha-->
              <div class="w-100 ">
                <form nz-frm>
                  <nz-table #editRowInternalTable nzBordered [nzData]="RECORD_PARTY_SIGN" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable1"
                            [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                    <tr>
                      <th class="text-center" nzWidth="25px">
                        {{
                          "enterprise_contract.panel_document.table_users.header.order"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="80%">
                        {{
                          "form.tbl_kyket"
                            | translate
                        }}
                      </th>
                      <th class="text-center">
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
                      <!-- TT -->
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- Tên -->
                      <td class="word-break-line">
                        <div class="editable-cell">
                          <div class="row-icon"> {{ data.name }}
                            <span *ngIf="data.email">- {{ data.email }}</span>
                          </div>
                        </div>
                      </td>
                      <!-- Action -->
                      <td class="td-nz-icon text-center">
                        <a nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                  'popup.confirm_delete_user' | translate
                }}" (nzOnConfirm)="onClickDeleteElementRecordInternalUserNew(data.customerId)"
                           nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                          <!-- <i class="nz-icon-font" nz-icon nzType="close-square" nzTheme="outline" nz-tooltip
               nzTitle="{{ 'tooltips.delete' | translate }}"></i> -->
                          <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                        </a>
                        <ng-template #iconDel>
                          <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                        </ng-template>
                      </td>
                    </tr>
                    <tr class="editable-row">
                      <!-- TT -->
                      <td class="text-center">&nbsp;</td>
                      <!-- Tên -->
                      <td colspan="2">
                        <div>
                          <nz-input-group [nzSuffix]="suffixPartyInput">
                            <input nz-input [(ngModel)]="inputPartyValue" (input)="onChangePartySignSearch($event)"
                                   [nzAutocomplete]="autoPartySearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                        'placeholder.input_paperNumber' | translate
                      }}" #focusPartyInput id="inputParty" />
                            <nz-autocomplete #autoPartySearching>
                              <nz-auto-option *ngFor="let party of filteredPartyOptions" (selectionChange)="
                          autocompletePartySelected($event, party)
                        " [nzValue]="''">
                                <div class="d-flex">
                                  <mat-icon class="mr-2">account_circle</mat-icon>
                                  <span style="line-height: 20px">
                          {{ party.name }} -
                                    {{
                                      party.taxCode && party.taxCode.length > 0
                                        ? party.taxCode
                                        : party.certificateNo
                                    }}
                        </span>
                                </div>
                                <div class="d-flex">
                                  <mat-icon class="mr-2">contact_mail</mat-icon>
                                  <span style="line-height: 20px">
                          <span *ngIf="party.email">{{ party.email }} -</span>
                                    {{ party.phone }}
                        </span>
                                </div>
                                <hr style="margin: 0; padding: 0" />
                              </nz-auto-option>
                            </nz-autocomplete>
                          </nz-input-group>
                          <ng-template #suffixPartyInput>
                            <i class="nz-icon-font" nz-icon nz-tooltip nzTitle="{{
                        'enterprise_contract.tooltips.icon_add_new_customer'
                          | translate
                      }}" nzType="plus-circle" nzTheme="outline" (click)="openAddCustomer()"
                               *ngIf="!nzCheckLoadingParty && !isFromSSO && checkDisplayBtnAddCustomer()">
                            </i>
                            <nz-spin *ngIf="nzCheckLoadingParty" nzSimple [nzIndicator]="indicatorPartyInput"></nz-spin>
                          </ng-template>
                          <ng-template #indicatorPartyInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                               style="font-size: 24px"></i>
                          </ng-template>
                        </div>
                      </td>
                      <!-- Thực hiện -->
                      <!--                      <td class="td-nz-icon text-center">&nbsp;</td>-->
                    </tr>
                    </tbody>
                  </nz-table>
                  <ng-template #contentEmptyTable1 ></ng-template>
                </form>
              </div>
            </form>
          </div>

          <!-- View contract -->
          <div *ngIf="mode === 'view'" class="mt-3">
            <nz-table #expandTableApprover [nzData]="RECORD_PARTY_SIGN" [nzFrontPagination]="false" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                      class="ant-table-no-placeholder-border-bottom" nzBordered>
              <thead>
              <tr>
                <th class="text-center" nzWidth="40px">
                  {{"approved.no" | translate }}
                </th>
                <th>
                  {{
                    "form.tbl_kyket"
                      | translate
                  }}
                </th>
                <th nzWidth="25px"></th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let data of expandTableApprover.data, index as i">
                <tr>
                  <td class="text-center">{{i+1}}</td>
                  <td class="font-weight-bold">{{data.name}}</td>
                  <td nzShowExpand [(nzExpand)]="mapOfExpandData[data.customerId]"></td>
                </tr>
                <tr [nzExpand]="mapOfExpandData[data.customerId]">
                  <td>&nbsp;</td>
                  <td class="td-detail-data" >
                    <span>{{'headertable.customer_code' | translate}}: {{data.customerCode}}<br /></span>
                    <span>{{'form.gpkd' | translate}} : {{data.certificateNo}}<br /></span>
                    <span>{{'footer.contact' | translate}}: <span *ngIf="data.email">{{data.email}}&nbsp;-&nbsp;</span>{{data.phone}} <br /></span>
                  </td>
                  <td>&nbsp;</td>
                </tr>
              </ng-container>
              </tbody>
            </nz-table>
            <ng-template #contentEmptyTable ></ng-template>
          </div>
        </mat-expansion-panel>


        <mat-expansion-panel expanded="true" class="mat-elevation-z mt-3" style="margin-left: -30px !important;" *ngIf="(mode === 'view' && filesAttachment && filesAttachment.length > 0) || mode !== 'view'">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title justify-content-between">
              {{'form.attach_file_list' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div *ngIf="mode !== 'view'">
            <app-upload-multi-file-attachments [isAttachFileForDocument]="true"
                                   [arrAttachments]="filesAttachment"
                                   [filesAttachmentOld]="filesAttachmentOld"
                                   [typeCreateContract]="1"
                                   [isEdit]="contractId"
                                   [maxSize]="maxSize"
                                   (fileAttachmentEmit)="changeFileAttachment($event)"
                                   (deleteFileEmit)="deleteFileAttachment($event)"
                                   [maxPerAttachFile]="maxPerAttachFile"
                                   [maxSizeSystem]="maxSizeSystem"
                                   [mainFiles]="mainFiles"
                                   >
            </app-upload-multi-file-attachments>
            <mat-hint class="hint-text d-flex justify-content-center">
              {{'hint.attach_accept_pdf_image_email' | translate}}
            </mat-hint>
          </div>
          <div *ngIf="mode === 'view'">
            <div class="mt-2 fix-width d-flex" *ngFor="let item of filesAttachment">
              <a (click)="downloadFile(item.id, item.fileName)" style="width: 90%;" class="text-truncate">
                <em class="fa fa-download fa-fw text-primary" matTooltip="{{ 'tooltips.download' | translate }}"></em>
                <span [matTooltip]="item.fileName"> {{ item.fileName }}</span>
              </a>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z mt-3"
                             expanded="true"
                             style="margin-left: -30px !important;"
                             #mePanel="matExpansionPanel" *ngIf="(mode === 'view' && contractEnterpriseCreated && contractEnterpriseCreated.length > 0)"
        >
          <mat-expansion-panel-header>
            <!-- Thông tin liên hệ -->
            <mat-panel-title class="mat-panel-title justify-content-between">
              <span>{{ 'form.sign_info' | translate }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- View contract -->
          <div  class="mt-3">
            <nz-table #expandTableApprover [nzData]="contractEnterpriseCreated" [nzFrontPagination]="false" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                      class="ant-table-no-placeholder-border-bottom" nzBordered>
              <thead>
              <tr>
                <th class="text-center" nzWidth="40px">
                  {{"approved.no" | translate }}
                </th>
                <th>
                  {{
                    "form.sign_info"
                      | translate
                  }}
                </th>
                <th nzWidth="25px"></th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let data of expandTableApprover.data, index as i">
                <tr>
                  <td class="text-center">{{i+1}}</td>
                  <td class="font-weight-bold">{{data.userName}}</td>
                  <td nzShowExpand [(nzExpand)]="mapOfExpandData[data.enterpriseId]"></td>
                </tr>
                <tr [nzExpand]="mapOfExpandData[data.enterpriseId]">
                  <td>&nbsp;</td>
                  <td class="td-detail-data sign-info" >
                    <span>{{'approved.processing_time' | translate}}: {{data.processedAt | dateformat}}<br /></span>
                    <span>{{'footer.contact' | translate}}: <b *ngIf="data.userEmail" style="font-weight: normal;">{{data.userEmail}}&nbsp;-&nbsp;</b>{{data.userPhone}} <br /></span>
                    <span>
                      <span *ngIf="data.signMethod">{{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_info' | translate }}:<br /></span>
                      <span class="ml-2" *ngIf="data.signMethod">- {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method' | translate }}: {{ (data.signMethod == 10 ? 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_cloud_ca' : 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_usb_token') | translate}} <br /></span>
                      <span class="ml-2" *ngIf="data.signMetadata.issuedTo">- {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.issued_to' | translate }}: {{data.signMetadata.issuedTo}}<br /></span>
                      <span class="ml-2" *ngIf="data.signMetadata.serialNumber">- {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.serial_number' | translate }}: {{data.signMetadata.serialNumber}}<br /></span>
                      <span class="ml-2" *ngIf="data.signMetadata.certificateNo">- {{ 'form.gpkd' | translate }}: {{data.signMetadata.certificateNo}}<br /></span>
                    </span>
                  </td>
                  <td>&nbsp;</td>
                </tr>
              </ng-container>
              </tbody>
            </nz-table>
            <ng-template #contentEmptyTable ></ng-template>
          </div>
        </mat-expansion-panel>
      </div>

      <!--      pdf-->
      <div class="view-digital-contract {{isViewFull ? 'w-100' : 'col-7'}} {{pdfSrc ? 'd-block' : 'd-flex'}}">
        <!-- [ngStyle]="{'background': !pdfSrc ? '#D6D6D6' : '#fff'}" -->
        <div [hidden]="pdfSrc || mode === 'view'" class="chooseFiles">
          <h3 style="color: #005e5b">
            {{ "enterprise_contract.panel_document.lb_create_document" | translate }}
          </h3>
          <br/>
          <button #btnUpload (click)="inputUpload.click()" [ngClass]="{ active_document: false }" class="mr-2"
                  color="primary" id="btnUpload" appTrackEvent="w.btn.hdsohoatoiquanly.them.chontumay"
                  mat-stroked-button type="button">
            <mat-icon class="mr-0">cloud_upload</mat-icon>
            {{ "button.choose_a_file" | translate }}
          </button>
          <input #inputUpload (change)="onSelectedUpload($event)" accept=".pdf"
                 class="form-control-file vt-input-form d-none mat-stroked-button-create-document" id="file"
                 multiple name="file" type="file"/>
          <h5 *ngIf="mode !== 'view'" style="margin-top: 2em; font-weight: bold; text-align: center;">
            ({{ mesage }})
          </h5>
          <br/><br/>
        </div>
        <div
          *ngIf="pdfSrc"
          style="width: 100%; position: relative; height: 52px; display: flex; align-items: center; background: #fff;">
          <div>
            <button (click)="isViewFull = !isViewFull" class="mr-2" color="primary" mat-stroked-button
                    style="min-width: 70px !important; max-width: 70px !important;"
                    [matTooltip]="(isViewFull ? 'enterprise_contract.tooltips.btn_expand_less' : 'enterprise_contract.tooltips.btn_expand_more') | translate"
            >
              <mat-icon class="mr-0">
                fullscreen
              </mat-icon>
            </button>
          </div>
          <div class="d-flex box-tab" cdkDropList cdkDropListOrientation="horizontal"
               (cdkDropListDropped)="drop($event)" style="width: 100%; margin-top: 0.5rem; height: 44px">
            <div (click)="changeFile(i)" *ngFor="let file of filesName; let i = index" cdkDrag
                 [cdkDragDisabled]="mode === 'view' ? true : false"
                 [class.active]="i === activeFile"
                 [class.border-right]="i !== filesName.length - 1 && i !== activeFile && i !== activeFile - 1"
                 [class.left]="i === activeFile - 1"
                 [class.right]="i === activeFile + 1"
                 [matTooltip]="file.name" class="pl-2 py-2 tab d-flex">
              <div [title]="file" class="name">
                {{ file }}
              </div>
              <a (click)="removeFile(i)"><span *ngIf="mode !== 'view'" class="material-icons"> close </span></a>
            </div>
          </div>
          <div *ngIf="mode !== 'view'">
            <button #btnUpload (click)="inputUpload.click()" [ngClass]="{ active_document: true }" class="ml-2"
                    color="primary" id="btnUpload" mat-stroked-button appTrackEvent="w.btn.hdsohoatoiquanly.them.chontumay"
                    style="min-width: 70px !important; max-width: 70px !important;" type="button"
                    [matTooltip]="'button.choose_a_file' | translate"
            >
              <mat-icon class="mr-0">cloud_upload</mat-icon>
            </button>
            <input #inputUpload (change)="onSelectedUpload($event)"
                   accept=".pdf"
                   class="form-control-file vt-input-form d-none mat-stroked-button-create-document" id="file"
                   multiple
                   name="file" type="file"/>
          </div>
          <div *ngIf="mode === 'view'" class="ml-2 d-flex">
            <button (click)="doPrint()" mat-stroked-button class="mr-2" color="primary"
                    style="min-width: 70px !important;">
              <mat-icon class="mr-0">print</mat-icon>
              {{ "enterprise_contract.buttons.print" | translate }}
            </button>

            <button (click)="downloadContract()" class="mr-2" color="primary" mat-stroked-button
                    style="min-width: 70px !important;"
                    [matTooltip]="'tooltips.download' | translate"
            >
              <mat-icon>save_alt
              </mat-icon>
              {{ 'button.download' | translate }}
            </button>
          </div>
        </div>
        <div *ngIf="pdfSrc === 'notPDF'" class="mt-5 d-flex justify-content-center px-5">
          <h5>
            {{ "digital_contract.error.fileNotSupportPreview" | translate }}
            <span *ngIf="mode === 'view'">{{ "digital_contract.error.download_please" | translate }}</span>
          </h5>
        </div>
        <ng-container *ngIf="pdfSrc && pdfSrc !== 'notPDF'">
          <ng-container *ngIf="pdfSrc !== 'notPDF' && !isViewParentContract">
            <ngx-extended-pdf-viewer (textLayerRendered)="textLayerFormRendered($event)" [enablePrint]="true"
                                     [language]="language" [showPrintButton]="false"
                                     [showBookmarkButton]="false" [showDownloadButton]="false"
                                     [showOpenFileButton]="false"
                                     [showPropertiesButton]="false" [showRotateButton]="false"
                                     [showSecondaryToolbarButton]="false"
                                     [showUnverifiedSignatures]="true" [sidebarVisible]="true" [src]="pdfSrc"
                                     [textLayer]="true"
                                     [theme]="'dark'"
                                     [zoom]="isViewFull ? 'page-width' : '100'"
                                     class="pdf-viewer" style="display: block; width: 100%; height: calc(100% - 52px)"
                                     useBrowserLocale="true"
                                     [httpHeaders]="authorization">
            </ngx-extended-pdf-viewer>
          </ng-container>
        </ng-container>
      </div>
    </mat-accordion>

  </mat-card-content>
  <div style="background-color: white"
       class="scontract-btn-dsk scontract-btn-deskbg-white boder-create-contract text-center mat-elevation-z0 py-2 w-100">
    <button *ngIf="mode !== 'view'" appTrackEvent="w.btn.hdsohoatoiquanly.them.huy_bo"
            (click)="cancelAdd()"
            class="mr-3"
            color="primary"
            id="btn-cancel"
            mat-stroked-button
            type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{ "button.cancel" | translate }}
    </button>
    <button *ngIf="mode === 'view'"
            (click)="cancelAdd()"
            class="mr-3" color="primary"
            mat-stroked-button
            type="button">
      <mat-icon class="mr-0">arrow_back</mat-icon>
      {{ "button.back" | translate }}
    </button>
    <button (click)="goToSign()" *ngIf="mode === 'view' && contractStatus == 1" class="mr-3" color="primary"
            mat-raised-button
            type="button">
      <mat-icon class="mr-0">gesture</mat-icon>
        {{ "enterprise_contract.buttons.sign" | translate }}
    </button>
    <button (click)="saveContract(true)" *ngIf="mode !== 'view'" class="mr-3" color="primary"
            mat-raised-button
            type="button">
      <mat-icon class="mr-0">gesture</mat-icon>
        {{ "enterprise_contract.buttons.sign" | translate }}
    </button>
    <button (click)="saveContract()" *ngIf="mode !== 'view'" class="mr-3" color="primary" mat-raised-button appTrackEvent="w.btn.hdsohoatoiquanly.them.lap_hd"
            type="button">
      <mat-icon class="mr-0">save</mat-icon>
      {{ (mode === 'create' ? "button.creare_doc" : "button.save") | translate }}
    </button>

    <button (click)="moveToUpdate()" *ngIf="mode === 'view' && !statusBackup && contractStatus == 1" class="mr-3" color="primary"
            mat-raised-button
            type="button">
      <!--        <mat-icon class="mr-0">save</mat-icon>-->
      {{ (mode === 'view' ? "button.update" : "button.creare_doc") | translate }}
    </button>

  </div>
</mat-card>
